import querystring from "querystring";
import { pickBy } from "ramda";
import { API_BASE_URL, AUTH_BASE_URL, LIBRARY_BASE_URL } from "../props";
import { notBlank } from "../util/ext";
import {
  useDelete,
  useGet,
  useGetWithCount,
  usePost,
  usePut,
  useUpdate,
} from "../common/fetchServices";

const LIMIT = 25;
export const LOGIN_URL = `${LIBRARY_BASE_URL}/login`;
export const VERIFY_EMAIL_URL = `${LIBRARY_BASE_URL}/verify-email`;

const getUserUrl = ({ id }) => `${AUTH_BASE_URL}/users/${id}`;
const getUserProfileUrl = ({ id }) => `${API_BASE_URL}/users/${id}`;
const getUserOrgUrl = ({ userId, organizationId }) =>
  `${AUTH_BASE_URL}/users/${userId}/organizations/${organizationId}`;

const getUserSearchUrl = (
  filter,
  roles,
  organization,
  orderBy,
  activeOnly,
  offset,
  limit,
) => {
  const params = pickBy((val, _key) => notBlank(val), {
    filter,
    roles,
    org: organization,
    order: orderBy,
    activeOnly,
    offset,
    limit,
  });

  return `${AUTH_BASE_URL}/users?${querystring.encode(params)}`;
};

export const useUsers = (
  filter,
  roles,
  organization,
  orderBy,
  activeOnly,
  page,
  limit = LIMIT,
) => {
  const offset = page * limit;
  const url = getUserSearchUrl(
    filter,
    roles,
    organization,
    orderBy,
    activeOnly,
    offset,
    limit,
  );

  return useGetWithCount(["users", { url }], url);
};

export const useOrganizations = () => {
  const url = `${AUTH_BASE_URL}/organizations?limit=all`;
  return useGet(["organizations-all"], url, true, true);
};

export const useUser = id => {
  const url = `${AUTH_BASE_URL}/users/${id}`;
  return useGet(["users", { id }], url);
};

export const useUserProfile = id => {
  const url = `${API_BASE_URL}/users/${id}`;
  return useGet(["user-profile", { id }], url);
};

export const useUserCreate = () => {
  return usePost(() => `${API_BASE_URL}/users`, {
    queriesToInvalidate: [["users"]],
  });
};

export const useUserUpdate = () => {
  return usePut(getUserUrl, {
    queriesToInvalidate: [["users"], ["users", ["id"]]],
  });
};

export const useUserProfileUpdate = () => {
  return useUpdate(getUserProfileUrl, {
    queriesToInvalidate: [["user-profile", ["id"]]],
  });
};

export const useAddUserOrganization = () => {
  return usePut(getUserOrgUrl, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useDeleteUserOrganization = () => {
  return useDelete(getUserOrgUrl, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useSendPasswordReset = () => {
  return usePost(() => `${AUTH_BASE_URL}/notifications/password_reset`, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useSendVerificationEmail = () => {
  return usePost(() => `${AUTH_BASE_URL}/notifications/verify_email`, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useSendCreatorAccountEmail = () => {
  return usePost(() => `${AUTH_BASE_URL}/notifications/creator_account`, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};
